import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { SalesforceConnection, SalesforceEnvironment } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';

@Component({
  selector: 'connection-form-salesforce',
  template: `
    <xp-form-validation type="SalesforceConnection" [name]="formName">
      <form id="connectionFormSalesforce" name="connectionFormSalesforce" #form="ngForm" class="form">
        <div *ngIf="!connectionTypeButtonCreate">
          <p class="lead">{{ 'connection-form-salesforce.sign_in_text' | translate }}</p>
        </div>
        <div class="row">
          <div class="col-md-6">
            <xp-form-group *ngIf="connection.unique_id || connection.code || connection.jwt_token">
              <label for="name">{{ 'connections.form.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
            <xp-form-group *ngIf="connection.username">
              <label for="username">{{ 'connections.form.labels.username' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="username"
                id="username"
                [(ngModel)]="connection.username"
                readonly
              ></xp-input>
            </xp-form-group>
            <div>
              <label for="environment_type">{{
                'connections.form.salesforce.labels.environment_type' | translate
              }}</label>
              <xp-select
                id="environment_type"
                class="form-control xp-select"
                [value]="connection.environment"
                [options]="environmentTypeOptions"
                (valueChange)="onEnvironmentTypeChange($event)"
              >
              </xp-select>
            </div>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormSalesforceComponent extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<SalesforceConnection> = {};
  @Input() connectionTypeButtonCreate: boolean;
  @Output() formValidationChange = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormSalesforce';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];
  environmentTypeOptions = [
    {
      value: SalesforceEnvironment.production,
      text: 'connections.form.salesforce.environment_types.production',
      translate: true,
    },
    {
      value: SalesforceEnvironment.sandbox,
      text: 'connections.form.salesforce.environment_types.sandbox',
      translate: true,
    },
  ];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
  ) {
    super();
  }

  onEnvironmentTypeChange(environmentType: SalesforceEnvironment) {
    this.connection.environment = environmentType;
  }
}
